import { isIE } from '@/utils/util'

/**
 * @apiDefine Authorization
 * The request requires Authorization Header
 * @apiHeader {String} Authorization After user login, login api return the jwt token, as the token to access restrictive resources
 * @apiHeaderExample {json} Header-Example:
 *   {
 *     "Authorization": "Bearer $token"
 *   }
 */

// 判断环境不是 prod 或者 preview 是 true 时，加载 mock 服务
if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
  if (isIE()) {
    console.error('ERROR: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.')
  }
  // 使用同步加载依赖
  // 防止 vuex 中的 GetInfo 早于 mock 运行，导致无法 mock 请求返回结果
  // console.log('mock mounting')
  const Mock = require('mockjs2')
  // require('./services/auth')
  require('./services/user')
  require('./services/manage')
  require('./services/other')
  require('./services/tagCloud')
  // require('./services/sitesEditor')

  Mock.setup({
    timeout: 800 // setter delay time
  })
}
